import {WalkOfShame} from "../WalkOfShame";
import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {Layers, WalkOfShameLayers} from "../view/WalkOfShameLayers";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {WalkOfShameGameMode} from "../server/WalkOfShameGameMode";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {WalkOfShameGameAssets} from "../WalkOfShameGameAssets";
import {TimelineLite} from "gsap";
import {WalkOfShameSound} from "../sound/WalkOfShameSound";

export class WinCapScreen extends ContinueScreen {
    private readonly _animation: PIXI.spine.Spine;
    private readonly _amount: BitmapCountUp;
    private readonly _happilyEverAfter: PIXI.spine.Spine;
    private readonly _winTimesX: PIXI.Sprite;
    private _winTimesTl: TimelineLite | null;

    constructor() {
        super(WalkOfShameLayers.getLayer(Layers.SCREENS)!);

        this._animation = new PIXI.spine.Spine(WalkOfShame.assetLoader.getSpineAsset("capWin"));
        this._animation.visible = false;
        this._animation.position.set(360);

        const style = {
            fontName: WalkOfShameGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 150,
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        };
        this._amount = new BitmapCountUp(style);
        this._amount.visible = false;
        this._amount.shrinkSize = true;
        this._amount.maxTextWidth = 580;
        this._amount.position.set(360);

        this._happilyEverAfter = new PIXI.spine.Spine(WalkOfShame.assetLoader.getSpineAsset("happilyEverAfter"));
        this._happilyEverAfter.visible = false;
        this._happilyEverAfter.scale.set(0.8);
        this._happilyEverAfter.position.set(360, 95);

        this._winTimesX = new PIXI.Sprite(WalkOfShame.assetLoader.getTextures("Capwin/9822x")[0]);
        this._winTimesX.anchor.set(0.5);
        this._winTimesX.position.set(360, 520);

        this.addChild(this._animation, this._amount, this._happilyEverAfter, this._winTimesX, this._continueButton);
    }

    public show(onContinueCallBack: () => void): void {
        super.show(onContinueCallBack);
        this._continueButton.visible = false;
        this._continueButton.enable(false);
        this._winTimesX.scale.set(0);

        const tl: TimelineLite = new TimelineLite(),
            totalWin: number = WalkOfShame.model.parsedGameData.totalWin;

        tl.add(() => {
            this._animation.visible = true;
            this._animation.updateTransform();
            this._animation.state.clearTracks();
            this._animation.state.setEmptyAnimation(0, 0);
            this._animation.state.setAnimation(0, "MrE", false);

            WalkOfShameSound.soundPlayer.playTrack({
                name: WalkOfShameSound.CAP_WIN_COUNT_UP
            });
            WalkOfShameSound.fadeMusic(0, 100);
        }, 0);
        tl.add(() => {
            this._amount.visible = true;
            this._amount.getCountUpAnimation(0.01, totalWin, 11.667);
        }, 1.666);
        tl.to(this._amount.scale, {
            duration: 0.2,
            x: 1.3,
            y: 1.3
        }, 13.333);
        tl.to(this._amount.scale, {
            duration: 0.2,
            x: 1,
            y: 1
        }, 13.6);
        tl.to(this._amount.scale, {
            duration: 0.35,
            x: 0,
            y: 0
        }, 14.3);
        tl.to(this._winTimesX.scale, {
            duration: 0.35,
            x: 0.75,
            y: 0.75
        }, 14.65);
        tl.add(() => {
            this._amount.visible = false;
            this._amount.scale.set(1);

            this._animation.state.setAnimation(0, "Loop", true);

            this._happilyEverAfter.visible = true;
            this._happilyEverAfter.updateTransform();
            this._happilyEverAfter.state.setEmptyAnimation(0, 0);
            this._happilyEverAfter.state.setAnimation(0, "animation", true);

            this.animateWinTimesX();

            this._continueButton.visible = true;
            this._continueButton.enable(true);

            WalkOfShame.keypadPlugin.setWin(totalWin, true, BelowStakeWinRestriction.isWinBelowStake());

            WalkOfShameSound.soundPlayer.playTrack({
                name: WalkOfShameSound.CAP_WIN_LOOP,
                repeat: Number.MAX_VALUE,
                volume: 1
            });
        }, 15);
    }

    protected close(): TimelineLite {
        const tl: TimelineLite = super.close();

        tl.add(() => {
            BelowStakeWinRestriction.reset();

            WalkOfShame.multiplier.toggleMultiplier(false);
            WalkOfShame.multiplier.updateMultiplierText(1, false);

            WalkOfShame.updateMode(WalkOfShameGameMode.NORMAL, false);

            WalkOfShameSound.fadeAndStopSound({
                name: WalkOfShameSound.CAP_WIN_LOOP,
                duration: 100,
                to: 0
            });
            WalkOfShameSound.soundPlayer.playTrack({
                name: WalkOfShameSound.CAP_WIN_END
            });
            WalkOfShameSound.fadeMusic(1, 100);
            WalkOfShameSound.switchMusic({
                name: WalkOfShameSound.getMusicNameByMode(WalkOfShameGameMode.NORMAL),
                volume: 1
            });
        }, 0);

        // on completion, so that animation's loop is turned off
        tl.add(() => {
            this._animation.visible = false;
            this._animation.state.clearTracks();

            this._happilyEverAfter.visible = false;
            this._happilyEverAfter.state.clearTracks();

            if (this._winTimesTl) {
                this._winTimesTl.pause();
                this._winTimesTl.kill();
                this._winTimesTl = null;
            }
        });

        return tl;
    }

    private animateWinTimesX(): void {
        this._winTimesTl = new TimelineLite({
            delay: 1,
            repeat: -1
        });
        this._winTimesTl.to(this._winTimesX, {
            duration: 3,
            alpha: 0.2
        });
        this._winTimesTl.to(this._winTimesX, {
            duration: 3,
            alpha: 1
        });
    }
}